app.controller("CreatePollController", ["$scope", "StaticData", "$stateParams", "$filter", "$uibModal", "PollService", "ProgramService", "Students", "Users", "$state", "ConfirmModal", "toastr",
    function ($scope, StaticData, $stateParams, $filter, $uibModal, PollService, ProgramService, Students, Users, $state, ConfirmModal, toastr) {
        $scope.totalStudents = 0;
        $scope.type = "options";
        $scope.question = null;
        $scope.answer = null;
        $scope.estimatedAnswers = [];
        $scope.program = null;
        $scope.level = null;
        $scope.state = null;
        $scope.faculty = null;
        $scope.anonymous = true;
        $scope.semester = 'სემესტრი';
        $scope.semesters = ['სემესტრი'].concat(_.range(1, 15));
        $scope.panelTitle = 'გამოკითხვის შექნა';
        $scope.buttonText = 'გაგზავნა';
        $scope.operationType = 'send';
        $scope.receiver = 'students';

        $scope.users = [];

        $scope.getUsers = function (query) {
            if (query.length < 2) {
                return [];
            }
            return Users.list({query: query}).then(function(data) {
                return data.docs.filter(function(usr) {
                    var el_index = _.findIndex($scope.users, function (user) {
                        return user._id === usr._id;
                    });
                    return el_index === -1;
                })
            });
        };

        $scope.$watch('user', function (val) {
            if (val && val._id) {
                $scope.users.push(val);
                $scope.user = null;
                $scope.totalItems =  $scope.users.length || 0;
            }
        }, true);

        $scope.delete_user = function (id) {
            var el_index = _.findIndex($scope.users, function (user) {
                return id === user._id;
            });

            $scope.users.splice(el_index, 1);
            $scope.totalItems =  $scope.users.length;
        };

        $scope.changeReceiver = function (newType) {
            $scope.totalItems = 0;
            $scope.receiver = newType;
        };

        if ($stateParams.operationType) $scope.operationType = $stateParams.operationType;
        if ($scope.operationType == 'edit') {
            $scope.panelTitle = 'გამოკითხვის რედაქტირება';
            $scope.buttonText = 'რედაქტირება';
        } else if ($scope.operationType == 'resend') {
            $scope.panelTitle = 'გამოკითხვის გადაგზავნა';
            $scope.buttonText = 'გადაგზავნა';
        }

        if ($stateParams.pollId) {
            PollService.getById({
                pollId: $stateParams.pollId
            }).then(function (poll) {
                $scope.question = poll.text;
                $scope.type = poll.type;
                $scope.anonymous = poll.anonymous;
                $scope.estimatedAnswers = poll.answers;
                $scope.faculty = poll.receivers.faculty;
                $scope.level = poll.receivers.level;
                $scope.program = poll.receivers.program;
                $scope.state = poll.receivers.state;
                if (poll.receivers.semester) $scope.semester = poll.receivers.semester;
            })
        }

        StaticData.getItemsByKey("faculties").then(function (faculties) {
            $scope.faculties = [{name: "ფაკულტეტი"}].concat(faculties);
        });

        StaticData.getItemsByKey("levels").then(function (levels) {
            $scope.levels = [{name: "საფეხური"}].concat(levels);
        });

        StaticData.getItemsByKey("states").then(function (states) {
            $scope.states = [{name: "სტატუსი"}].concat(states);
        });

        $scope.getPrograms = function (name) {
            if (name.length < 1) {
                return [];
            }
            var params = {};
            params.query = name;
            return ProgramService.list(params).then(function (data) {
                return data.docs;
            });
        };

        $scope.change = function (newType) {
            $scope.type = newType;
        };

        $scope.changeAnonymous = function (newType) {
            $scope.anonymous = newType;
        };

        $scope.getStudents = function () {
            Students.list({
                query: $scope.query,
                faculty: $scope.faculty,
                level: $scope.level,
                state: $scope.state,
                semester: $scope.semester !== 'სემესტრი' ? $scope.semester : undefined,
                program: $scope.program ? $scope.program._id : undefined,
            }).then(function (data) {
                $scope.totalStudents = data.total
            });
        };

        $scope.getStudents();

        $scope.$watch('program', function (val) {
            if (val && val._id) {
                $scope.getStudents()
            }
        }, true);

        $scope.show = function () {
            var poll = {
                text: $scope.question,
                title: $scope.title,
                priority: $scope.priority,
                answers: $scope.estimatedAnswers,
                anonymous: $scope.anonymous,
                type: $scope.type
            };
            $uibModal.open({
                controller: "PollsWindowController",
                templateUrl: _pb + 'admin/polls/poll-window.html',
                size: "md",
                resolve: {
                    params: function () {
                        return {poll: poll};
                    }
                }
            }).result
                .then(function (result) {

                }, function (error) {

                });
        };

        $scope.add = function () {
            if (!$scope.answer) return toastr.error('', 'გთხოვთ ჩაწეროთ სავარაუდო პასუხი');
            if ($scope.estimatedAnswers.indexOf($scope.answer) === -1) $scope.estimatedAnswers.push($scope.answer);
            $scope.answer = null;
        };

        $scope.remove = function (answer) {
            var index = $scope.estimatedAnswers.indexOf(answer);
            $scope.estimatedAnswers.splice(index, 1)
        };

        $scope.send = function () {
            var poll = {
                _id: $stateParams.pollId,
                update: $scope.operationType === 'edit',
                text: $scope.question,
                type: $scope.type,
                anonymous: $scope.anonymous,
                answers: $scope.estimatedAnswers,
                receiversList: [],
                receivers: {
                    type: $scope.reciever,
                    state: $scope.state,
                    faculty: $scope.faculty,
                    program: $scope.program ? $scope.program._id : null,
                    level: $scope.level,
                    semester: $scope.semester !== 'სემესტრი' ? $scope.semester : null
                }
            };

            if($scope.receiver == 'users') {
                poll.receiversList = $scope.users;
            }

            if (!$scope.question) toastr.error('', 'გთხოვთ ჩაწეროთ კითხვა');
            else if ($scope.type == 'options' && $scope.estimatedAnswers.length == 0) {
                toastr.error('', 'გთხოვთ დაამატოთ სავარაუდო პასუხები');
            }
            else {
                if ($scope.operationType == 'send') {
                    PollService.send(poll).then(function () {
                        toastr.success('', 'გამოკითხვა გაგზავნილია');
                        $state.go('admin.send.polls');
                    }).catch(function () {
                        toastr.error('', 'გამოკითხვის გაგზავნისას დაფიქსირდა შეცდომა');
                    })
                }
                else if ($scope.operationType == 'resend') {
                    PollService.send(poll).then(function () {
                        toastr.success('', 'გამოკითხვა გადაგზავნილია');
                        $state.go('admin.send.polls')
                    }).catch(function () {
                        toastr.error('', 'გამოკითხვის გადაგზავნისას დაფიქსირდა შეცდომა');
                    })
                }
                else if ($scope.operationType == 'edit') {
                    ConfirmModal.show({
                        title: "ყურადღება",
                        message: "გამოკითხვა პირვანდელი სახით წაიშლება და შეინახება მხოლოდ რედაქტირებული"
                    }).result.then(function () {
                        PollService.send(poll).then(function () {
                            toastr.success('', 'გამოკითხვა რედაქტირებულია');
                            $state.go('admin.send.polls')
                        }).catch(function () {
                            toastr.error('', 'გამოკითხვის რედაქტირებისას დაფიქსირდა შეცდომა');
                        })
                    });
                }
            }
        };
    }
]);